// Mock dropdown options for General Info and related fields
export const mockDropdownOptions = {
  productGroups: [
    { id: 'creative-cloud', name: 'Creative Cloud' },
    { id: 'document-cloud', name: 'Document Cloud' },
    { id: 'experience-cloud', name: 'Experience Cloud' },
    { id: 'firefly', name: 'Firefly' }
  ],
  categories: [
    { id: 'firefly', name: 'Firefly.com', productGroupId: 'firefly' },
    { id: 'photoshop', name: 'Photoshop', productGroupId: 'creative-cloud' },
    { id: 'acrobat', name: 'Acrobat', productGroupId: 'document-cloud' }
  ],
  tiers: [
    { id: 'L1', name: 'L1' },
    { id: 'L2', name: 'L2' },
    { id: 'L3', name: 'L3' },
    { id: 'Other', name: 'Other' }
  ],
  releasePhases: [
    { id: 'internal-beta', name: 'Internal Beta' },
    { id: 'private-beta', name: 'Private Beta' },
    { id: 'public-beta', name: 'Public Beta' },
    { id: 'ga-existing', name: 'GA - Existing' },
    { id: 'ga-1-0', name: 'GA - 1.0 Release' }
  ],
  statuses: [
    { id: 'low', name: 'Risk Level: Low' },
    { id: 'moderate', name: 'Risk Level: Moderate' },
    { id: 'high', name: 'Risk Level: High' }
  ],
  events: [],
  parentMoments: [],
  momentTypes: [
    { id: 'release-with-marketing', name: 'Release w/ Marketing' },
    { id: 'release-without-marketing', name: 'Release w/o Marketing' },
    { id: 'marketing-moment', name: 'Marketing Moment' },
    { id: 'offer-price-program', name: 'Offer, Price Change or Program' },
    { id: 'policy-change', name: 'Policy Change' },
    { id: 'key-date', name: 'Key Date' },
    { id: 'event', name: 'Event' },
    {
      id: 'Product Release without Marketing',
      name: 'Product Release without Marketing'
    }
  ],
  tags: [
    { id: 'genai', name: 'GenAI' },
    { id: 'beta', name: 'Beta' },
    { id: 'mobile', name: 'Mobile' }
  ]
};
